import { DATE_FORMAT, TIME_FORMAT_WITH_NO_SECOND, format } from 'date-util';
import { FC, memo } from 'react';

export type Props = {
  value?: string | null;
  showTime?: boolean;
};

export const DateTimeCell: FC<Props> = memo(({ value, showTime = false }) => {
  const date = format(value, DATE_FORMAT);
  if (!date) return null;

  if (!showTime) return <>{date}</>;

  const time = format(value, TIME_FORMAT_WITH_NO_SECOND);

  return (
    <>
      <div>{date}</div>
      <div>{time}</div>
    </>
  );
});

DateTimeCell.displayName = 'DateTimeCell';
